import { useState } from 'react'

type Props = {
  forceImage?: string
}

export const BackgroundImage = ({
  forceImage
}: Props) => {

  const images: string[] = [
      'sunflowers-bg.jpg',
      'maroon-bells-bg.jpg'
  ];

  const [bgImage, setBgImage] = useState(forceImage || '')

  const randomIndex: number = Math.floor(Math.random() * images.length);
  const selectedImage = images[randomIndex];

  if (bgImage === '') {
    setBgImage(selectedImage)
  }

  return (
    <div
      className="h-screen flex flex-col"
      style={{
        position: 'absolute',
        backgroundImage: `url(${bgImage})`,
        backgroundPosition: 'top center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        height: '100%',
        width: '100%'
      }}
    >
    </div>
  )
}
